import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DatePicker, SelectMenu, toast, BackdropLoader, getUtility, Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, InputAdornment, InputLabel, MenuItem, OutlinedInput, TextField, ToggleButton, ToggleButtonGroup, Typography, IconButton } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { USER_ROLES_BY_NAME, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { postChargeCreditInitialValues, postChargeCreditSchema } from 'src/utils/formValidation/Transaction';
import useStyles from './styles';
const PostChargeDetails = observer(_ref => {
  var _formik$values$title$, _formik$values$title;
  let handleClose = _ref.handleClose;
  const classes = useStyles();
  const history = useLocation();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const params = new URLSearchParams(history.search);
  const accountId = params.get('accountId');
  const propertyId = params.get('propertyId');
  const showAdminFee = USER_ROLES_BY_NAME[localStorage.getItem(USER_SETTINGS_KEYS.userRole)] === USER_ROLES_BY_NAME.LivableAdmin || USER_ROLES_BY_NAME[localStorage.getItem(USER_SETTINGS_KEYS.userRole)] === USER_ROLES_BY_NAME.LivableSuperAdmin || store.userRole === USER_ROLES_BY_NAME.LivableAdmin || store.userRole === USER_ROLES_BY_NAME.LivableSuperAdmin;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    chosenDate = _useState2[0],
    setChosenDate = _useState2[1];
  const titleMaxLength = 60;
  const _useState3 = useState('charge'),
    _useState4 = _slicedToArray(_useState3, 2),
    chargeType = _useState4[0],
    setChargeType = _useState4[1];
  const handleChargeTypeChange = (e, value) => {
    if (value) setChargeType(value);
  };
  const repeatOn = 'OnStatementIssued';
  const _useState5 = useState('month'),
    _useState6 = _slicedToArray(_useState5, 2),
    occurancy = _useState6[0],
    setOccurancy = _useState6[1];
  const handleOccurancyChange = (e, value) => {
    if (value) setOccurancy(value);
  };
  const _useState7 = useState('OnMoveOut'),
    _useState8 = _slicedToArray(_useState7, 2),
    ends = _useState8[0],
    setEnds = _useState8[1];
  const handleEndsChange = (e, value) => {
    if (value) setEnds(value);
  };
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    notifyResident = _useState0[0],
    setNotifyResident = _useState0[1];
  const _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    numberOfOccurrences = _useState10[0],
    setNumberOfOccurrences = _useState10[1];
  const _useState11 = useState('Miscellaneous'),
    _useState12 = _slicedToArray(_useState11, 2),
    transactionType = _useState12[0],
    setTransactionType = _useState12[1];
  const _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    customChargeOnDate = _useState14[0],
    setCustomChargeOnDate = _useState14[1];
  const _useState15 = useState('Charge on date'),
    _useState16 = _slicedToArray(_useState15, 2),
    datePickerLabel = _useState16[0],
    setDatePickerLabel = _useState16[1];
  const _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    defaultChargeOnDateValue = _useState18[0],
    setDefaultChargeOnDateValue = _useState18[1];

  // The utilities this property bills, grouped by provider, as the Type dropdown offers them.
  const _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    utilities = _useState20[0],
    setUtilities = _useState20[1];
  const getLabel = () => {
    if (customChargeOnDate) return 'Charge on date';else if (defaultChargeOnDateValue) return moment(defaultChargeOnDateValue).format('MM/DD/YYYY');
    return 'Charge on date';
  };

  // const [due, setDue] = useState('on-receipt');
  // const handleDueChange = (e, value) => {
  //   if (value) setDue(value);
  // };

  // const [splitType, setSplitType] = useState('per-resident');
  // const handleSplitTypeChange = (e, value) => {
  //   if (value) setSplitType(value);
  // };

  const _useState21 = useState(moment().toDate()),
    _useState22 = _slicedToArray(_useState21, 2),
    repeatingMonth = _useState22[0],
    setRepeatingMonth = _useState22[1];
  const handleStartDate = _ref2 => {
    let date = _ref2.date;
    setRepeatingMonth(moment(date).toDate());
  };
  const postCustomCharge = async data => {
    const resp = await store.transaction.postCustomChargeAsync.run(data);
    return resp;
  };
  const postCustomCredit = async data => {
    const resp = await store.transaction.postCustomCreditAsync.run(data);
    return resp;
  };
  const scheduledCustomTransaction = async data => {
    const resp = await store.transaction.scheduledCustomTransactionAsync.run(data);
    return resp;
  };

  /**
   * The Type dropdown offers the utilities the property bills, so a posted charge can be tied to the
   * right GL code. It used to offer the residency's ratio-billed utilities, which only exist when the
   * residency is set to Bill and the PM ticked them, so a property billed any other way offered none
   * (LB-5593). BatchPostChargeModal already reads them this way.
   */
  const getUtilities = async () => {
    var _resp$response;
    if (!propertyId) return;
    const resp = await store.properties.getPropertyUtilityProvidersV3Async.run({
      propertyId
    });
    setUtilities(((_resp$response = resp === null || resp === void 0 ? void 0 : resp.response) !== null && _resp$response !== void 0 ? _resp$response : []).map(provider => {
      var _provider$utilities;
      return {
        providerName: provider.utilityProviderName,
        utilities: ((_provider$utilities = provider.utilities) !== null && _provider$utilities !== void 0 ? _provider$utilities : []).map(utility => ({
          name: utility.utilityType,
          utilityId: utility.utilityId,
          propertyUtilityId: utility.id
        }))
      };
    }));
  };
  const callback = resp => {
    if (resp && resp.isSuccessful) {
      store.transaction.setUpdateData();
      toast('success', {
        body: ['Custom transaction scheduled successfully'] // ? i18n
      });
      handleClose();
    }
  };
  const formik = useFormik({
    initialValues: postChargeCreditInitialValues,
    validationSchema: postChargeCreditSchema,
    onSubmit: async values => {
      try {
        const data = {
          amount: +values.amount,
          memo: values.memo,
          notes: values.notes,
          notifyResident: notifyResident,
          propertyId,
          type: values.type,
          userAccountId: accountId,
          title: values.title
        };
        if (store.company.companyFeatureStore.isAppfolio) data.appfolioChargeOnDate = customChargeOnDate;
        if (values.postType === 'recurring') {
          data.monthlyRepeatCondition = repeatOn;
          data.postType = chargeType;
          data.repeatOnMonth = moment(repeatingMonth).format('M') || 1; // ! need to add
          data.repeatRate = occurancy;
          data.endingCondition = ends;
          data.endingDateOnly = ends === 'OnDate' ? moment(chosenDate).format(moment.HTML5_FMT.DATE) : null;
          data.endingNumberOfOccurrences = ends === 'OnNumberOfOccurrences' ? Number(numberOfOccurrences) : null;
          scheduledCustomTransaction(data).then(callback);
        } else {
          if (transactionType === 'Miscellaneous') data.type = 'Miscellaneous';else if (transactionType === 'AdminFee') data.type = 'AdminFee';else data.type = 'Utility';
          data.utilityId = transactionType === 'Miscellaneous' || transactionType === 'AdminFee' ? null : transactionType.utilityId;
          data.propertyUtilityId = transactionType === 'Miscellaneous' || transactionType === 'AdminFee' ? null : transactionType.propertyUtilityId;
          if (chargeType === 'charge') {
            postCustomCharge(data).then(callback);
          } else {
            postCustomCredit(data).then(callback);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  });
  const handlePostTypeChange = (e, value) => {
    if (value) {
      formik.setFieldValue('postType', e.target.value);
    }
    if (value === 'recurring') {
      setTransactionType('Miscellaneous');
      setNotifyResident(false);
    }
  };
  const getChargeOnDate = async () => {
    await store.allocations.getCurrentCycleAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    await store.appfolioPropertiesApi.getDefaultChargeOnDateAsync.run({
      propertyId,
      allocationCycleMonth: store.allocations.currentCycle.month,
      allocationCycleYear: store.allocations.currentCycle.year
    }).then(getSettingsByBillIdAsyncResp => {
      if (getSettingsByBillIdAsyncResp !== null && getSettingsByBillIdAsyncResp !== void 0 && getSettingsByBillIdAsyncResp.isSuccessful) {
        setDefaultChargeOnDateValue(getSettingsByBillIdAsyncResp.response);
        setDatePickerLabel("Charge on date will be set to ".concat(moment(getSettingsByBillIdAsyncResp.response).format('MM/DD/YYYY')));
      }
    });
  };
  useEffect(() => {
    getUtilities();
    if (store.company.companyFeatureStore.isAppfolio) getChargeOnDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, formik.values.postType === 'recurring' ? t('post_charge_modal.recurring_typed_title', {
    type: chargeType
  }) : t('post_charge_modal.typed_title', {
    type: chargeType
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.titleField,
    onChange: e => {
      var _e$target;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value.length) <= titleMaxLength) {
        formik.setFieldValue('title', e.target.value);
      }
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "title"
  }, t('post_charge_modal.title')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "title",
    label: t('post_charge_modal.title'),
    type: "text",
    value: formik.values.title,
    touched: true,
    error: formik.errors.title
  }), !!formik.errors.title && /*#__PURE__*/React.createElement(FormHelperText, null, formik.errors.title), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", (_formik$values$title$ = (_formik$values$title = formik.values.title) === null || _formik$values$title === void 0 ? void 0 : _formik$values$title.length) !== null && _formik$values$title$ !== void 0 ? _formik$values$title$ : 0, "/", titleMaxLength, ")"))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.what_to_post')), /*#__PURE__*/React.createElement("div", {
    className: classes.typeBlock
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: chargeType,
    onChange: handleChargeTypeChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "charge"
  }, t('post_charge_modal.charge')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "credit"
  }, t('post_charge_modal.credit'))), /*#__PURE__*/React.createElement(SelectMenu, {
    id: "type",
    label: "Type",
    labelId: "type-label",
    onChange: e => {
      if (e.target.value !== 'headerName') setTransactionType(e.target.value);
    },
    value: transactionType
  }, formik.values.postType === 'OneTime' ? utilities.map((provider, index) => {
    return [/*#__PURE__*/React.createElement(MenuItem, {
      key: provider.providerName + '_' + index,
      id: provider.providerName,
      className: classes.chargeCreditTypeHeader,
      value: 'headerName',
      onClick: event => event.stopPropagation()
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      component: 'span'
    }, provider.providerName)), ...provider.utilities.map(utility => /*#__PURE__*/React.createElement(MenuItem, {
      key: utility.propertyUtilityId,
      value: utility,
      className: classes.chargeCreditType
    }, getUtility(utility.name).icon(), " ", utility.name))];
  }) : null, /*#__PURE__*/React.createElement(MenuItem, {
    key: 'other_header',
    id: 'other_header',
    className: classes.chargeCreditTypeHeader,
    value: 'headerName',
    onClick: event => event.stopPropagation()
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "disabled",
    component: 'span'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: 'span'
  }, 'Other'))), showAdminFee ? /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.chargeCreditType,
    key: 'AdminFee',
    id: 'AdminFee',
    value: "AdminFee"
  }, "Admin Fee") : null, /*#__PURE__*/React.createElement(MenuItem, {
    key: 'Miscellaneous',
    id: 'Miscellaneous',
    value: "Miscellaneous",
    className: classes.chargeCreditType
  }, t('post_charge_modal.miscellaneous')))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.post_type'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: formik.values.postType,
    onChange: handlePostTypeChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OneTime"
  }, t('post_charge_modal.one_time')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(ToggleButton, {
    value: "recurring"
  }, t('post_charge_modal.recurring')))), formik.values.postType === 'recurring' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('post_charge_modal.repeat_every'), " ", t('post_charge_modal.will_be_posted'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: occurancy,
    onChange: handleOccurancyChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "month"
  }, t('post_charge_modal.month')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "year"
  }, t('post_charge_modal.year'))), occurancy === 'year' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: t('post_charge_modal.month'),
    format: "MMMM",
    value: repeatingMonth,
    onChange: date => handleStartDate({
      date
    }),
    showMonthYearPicker: true,
    minDate: moment().toDate()
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('post_charge_modal.ends'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: ends,
    onChange: handleEndsChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnMoveOut"
  }, t('post_charge_modal.on_move_out')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnDate"
  }, t('post_charge_modal.on_date')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnNumberOfOccurrences"
  }, t('post_charge_modal.after_occurences')))), ends === 'OnDate' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: chosenDate,
    onChange: date => setChosenDate(date),
    format: "MM/dd/yy",
    minDate: moment().toDate()
  })), ends === 'OnNumberOfOccurrences' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.smallField)
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('post_charge_modal.num_of_occurances'),
    variant: "outlined",
    fullWidth: true,
    type: "number",
    onKeyPress: event => {
      if (!/^[+-]?\d+(\.\d+)?$/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      setNumberOfOccurrences(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.details'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.smallField,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      formik.setFieldValue('amount', e.target.value);
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "amount"
  }, t('post_charge_modal.enter_amount')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "amount",
    label: t('post_charge_modal.enter_amount'),
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    type: "number",
    value: formik.values.amount
  }), formik.touched.amount && !!formik.errors.amount && /*#__PURE__*/React.createElement(FormHelperText, null, "It should be a number and greater than 0"))), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.customChargeOnDateDatePicker, " ").concat(classes.actionsBar)
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: 'top',
    title: customChargeOnDate ? '' : datePickerLabel,
    type: 'success-bold-dark'
  }, /*#__PURE__*/React.createElement(DatePicker, {
    format: "MM/dd/yyyy",
    label: getLabel(),
    onChange: date => {
      const formatedDate = date === null || date === '' ? null : moment(date).format('YYYY-MM-DD');
      setCustomChargeOnDate(formatedDate);
    },
    value: customChargeOnDate !== null ? moment(customChargeOnDate).toDate() : null
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    style: {
      width: '48px',
      height: '48px',
      marginLeft: '6px'
    },
    disabled: customChargeOnDate === null || customChargeOnDate === undefined,
    onClick: () => {
      setCustomChargeOnDate(null);
    },
    'custom-attribute': '858-property-utilities-setup-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t("Set the date to post the charge or credit — if you leave it blank, we’ll use date from property settings. If it's not set - we’ll use today’s date."),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "memo",
    label: t('resident_account.memo'),
    value: formik.values.memo,
    onChange: e => {
      if (e.target.value.length <= 255) formik.handleChange(e);
    },
    variant: "outlined",
    multiline: true,
    type: "text"
    // maxRows={10}
    ,
    rows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", formik.values.memo.length, "/255)")), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "notes",
    label: t('resident_account.notes'),
    onChange: e => {
      if (e.target.value.length <= 255) formik.handleChange(e);
    },
    value: formik.values.notes,
    variant: "outlined",
    multiline: true,
    type: "text"
    // maxRows={10}
    ,
    rows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", formik.values.notes.length, "/255)")), store.account.profilesEmail.get(accountId) && formik.values.postType !== 'recurring' ? /*#__PURE__*/React.createElement("div", {
    className: classes.notificationCheckbox
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      onChange: e => setNotifyResident(e.target.checked),
      value: formik.values.notifyResident
    }),
    label: t('post_charge_modal.send_in-app_notifications')
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleClose(),
    'custom-attribute': '246-PostChargeModal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !formik.isValid || store.transaction.postCustomChargeAsync.inProgress || store.transaction.postCustomCreditAsync.inProgress || store.transaction.scheduledCustomTransactionAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress,
    form: "credit",
    onClick: () => formik.handleSubmit(),
    type: "submit",
    variant: "contained",
    'custom-attribute': '247-PostChargeModal'
  }, t('buttons.submit')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.transaction.postCustomChargeAsync.inProgress || store.transaction.postCustomCreditAsync.inProgress || store.transaction.scheduledCustomTransactionAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress
  }));
});
PostChargeDetails.propTypes = {
  batchPostCharge: PropTypes.bool
};
export default PostChargeDetails;